import { render, staticRenderFns } from "./RecordWeekDays.vue?vue&type=template&id=12f2195d"
import script from "./RecordWeekDays.vue?vue&type=script&lang=js"
export * from "./RecordWeekDays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports